import { decodeToken } from 'react-jwt';
import { COMBINED_TOKEN_KEY, LAST_USED_HUB_STORAGE_KEY } from '../../../constants';
import { jwtDoesNotContainText } from '../../../util/decodeJwt';
import { getSelectedInstanceState } from '../selectedInstanceHelper';
export const CURRENT_EVO_INSTANCE_KEY = 'evo';
export const LICENSE_TOKEN_KEY = 'token';
export const ALL_EVO_INSTANCES_KEY = 'allEvo';
export const ALL_CENTRAL_INSTANCES_KEY = 'allCentral';
export const FAKE_LOCAL_BMS_INSTANCE_CODE = 'local-bms';
export const BMS_DEV_TARGETED_HUB_CODE = '263bms';
export const BMS_LOCAL_DEV_URL = 'blockmodel.dev-sqnt.com:4001';
export const EVO_INSTANCE_USER_ROLE = 'evoUserRole';
export const ORG_INSTANCE_ACCESS = 'orgInstanceAccess';
export function getCurrentUserDetails() {
    const accessToken = JSON.parse(localStorage.getItem(COMBINED_TOKEN_KEY) || '{}');
    const decodedToken = decodeToken(accessToken === null || accessToken === void 0 ? void 0 : accessToken.access_token);
    if (decodedToken) {
        const userDetails = {
            data: {
                given_name: decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.given_name,
                family_name: decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.family_name,
                email: decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.email,
                sub: decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.sub,
            },
            isLoading: false,
            isFetching: false,
            isError: false,
            error: null,
        };
        return userDetails;
    }
    return undefined;
}
export function getLastUsedHub() {
    var _a;
    const lastUsedHubCode = JSON.parse((_a = localStorage.getItem(LAST_USED_HUB_STORAGE_KEY)) !== null && _a !== void 0 ? _a : '{}').code;
    const entitlements = getAvailableEvoInstances();
    const lastUsedEntitlement = entitlements.find((ent) => ent.hub.code === lastUsedHubCode);
    if (lastUsedEntitlement) {
        return lastUsedEntitlement;
    }
    localStorage.removeItem(LAST_USED_HUB_STORAGE_KEY);
    return undefined;
}
export function setLastUsedHub(code) {
    localStorage.setItem(LAST_USED_HUB_STORAGE_KEY, JSON.stringify({ code }));
}
export function setCurrentEvoInstance(entitlements) {
    sessionStorage.setItem(CURRENT_EVO_INSTANCE_KEY, JSON.stringify(entitlements));
}
export function getCurrentEvoInstance() {
    try {
        return JSON.parse(sessionStorage.getItem(CURRENT_EVO_INSTANCE_KEY) || '{}');
    }
    catch (_error) {
        return {};
    }
}
export function setAvailableEvoInstances(instances) {
    localStorage.setItem(ALL_EVO_INSTANCES_KEY, JSON.stringify(instances));
}
function addLocalBmsInstance(instances) {
    for (const instance of instances) {
        if (instance.hub.code === BMS_DEV_TARGETED_HUB_CODE) {
            const localhostBmsInstance = {
                hub: {
                    code: FAKE_LOCAL_BMS_INSTANCE_CODE,
                    display_name: 'Local BMS',
                    url: `${window.location.origin}/local-mock-services`,
                },
                org: Object.assign(Object.assign({}, instances[0].org), { display_name: `(Local BMS)` }),
            };
            instances.push(localhostBmsInstance);
            return instances;
        }
    }
    return instances;
}
export function getAvailableEvoInstances() {
    try {
        let instances = JSON.parse(localStorage.getItem(ALL_EVO_INSTANCES_KEY) || '[]');
        if (window.location.host === BMS_LOCAL_DEV_URL &&
            instances.length >= 1) {
            instances = addLocalBmsInstance(instances);
        }
        return instances;
    }
    catch (_error) {
        return [];
    }
}
export function setLicenseToken(jwtToken) {
    const filteredToken = jwtToken
        .split('&')
        .filter((token) => jwtDoesNotContainText(token, 'denied'))
        .join('&');
    sessionStorage.setItem(LICENSE_TOKEN_KEY, filteredToken);
}
export function getLicenseToken() {
    return sessionStorage.getItem(LICENSE_TOKEN_KEY);
}
export function getAdminFromToken() {
    const license = getLicenseToken();
    const decodedToken = decodeToken(license || '');
    return !!(decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.is_admin);
}
export function setCentralInstances(instances) {
    localStorage.setItem(ALL_CENTRAL_INSTANCES_KEY, JSON.stringify(instances));
}
export function getCentralInstances() {
    try {
        return JSON.parse(localStorage.getItem(ALL_CENTRAL_INSTANCES_KEY) || '{servers: []}');
    }
    catch (_error) {
        return { servers: [] };
    }
}
export function getCurrentCentralInstance() {
    const selectedInstanceState = getSelectedInstanceState();
    const centralInstances = getCentralInstances();
    return centralInstances.servers.find((server) => server.host === selectedInstanceState);
}
export function getRoles() {
    const access = getOrgInstanceAccess();
    if (access == null) {
        return null;
    }
    return access.roles || [];
}
export function setOrgInstanceAccess(licenseAccess) {
    sessionStorage.setItem(ORG_INSTANCE_ACCESS, JSON.stringify(licenseAccess));
}
export function getOrgInstanceAccess() {
    const item = sessionStorage.getItem(ORG_INSTANCE_ACCESS);
    if (item == null) {
        return null;
    }
    try {
        return JSON.parse(sessionStorage.getItem(ORG_INSTANCE_ACCESS) || '{}');
    }
    catch (_error) {
        return {};
    }
}
export function getCurrentOrgId() {
    var _a, _b;
    return ((_b = (_a = getCurrentEvoInstance()) === null || _a === void 0 ? void 0 : _a.org) === null || _b === void 0 ? void 0 : _b.id) || '';
}
export function clearEntitlements() {
    sessionStorage.removeItem(CURRENT_EVO_INSTANCE_KEY);
    sessionStorage.removeItem(LICENSE_TOKEN_KEY);
    sessionStorage.removeItem(ORG_INSTANCE_ACCESS);
    localStorage.removeItem(ALL_EVO_INSTANCES_KEY);
    localStorage.removeItem(ALL_CENTRAL_INSTANCES_KEY);
}
//# sourceMappingURL=entitlementsHelper.js.map